import { render, staticRenderFns } from "./DictDataListModal.vue?vue&type=template&id=081fcfa4&"
import script from "./DictDataListModal.vue?vue&type=script&lang=js&"
export * from "./DictDataListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports